<template>
	<!-- 执行标准 -->
	<div class="container_page">
		<div class="lang-radio-wrap">
			<a-radio-group v-model="filterData.lang" button-style="solid" @change="changeTabTop">
				<a-radio-button value="CH">中文版</a-radio-button>
				<a-radio-button value="EN">英文版</a-radio-button>
			</a-radio-group>
		</div>

		<a-form layout="inline" style="margin-bottom: 20px;">
			<a-form-item label="关键字" >
				<a-input v-model="filterData.keywords" placeholder="请输入关键字" />
			</a-form-item>
			<a-form-item label="时间范围">
				<a-range-picker v-model="filterData.timeDate" class="mr12" />
			</a-form-item>
			<!-- <a-form-item label="执行状态">
				<a-select style="width: 200px" v-model="filterData.implementationStatus" class="mr12"
					placeholder="请选择执行状态" show-search option-filter-prop="name" :filter-option="filterOption">
					<a-select-option v-for="(item, index) of commodityStatusList" :key="index" :value="item.value">
						{{ item.label }}
					</a-select-option>
				</a-select>
			</a-form-item> -->
			<a-form-item>
				<a-button class="mr12" type="primary" @click="toSearch(true)">查询</a-button>
				<a-button class="mr12" @click="toSearch(false)">重置</a-button>

				<!-- <a-button class="mr12" @click="scriptEdit">话术编辑</a-button>
				<a-button class="mr12">导入</a-button> -->
				<a-dropdown :trigger="['click']">
					<a-button>发布消息 <a-icon type="down" /></a-button>
					<a-menu slot="overlay" @click="handleMenuClick">
						<a-menu-item key="SHORT">短消息</a-menu-item>
						<a-menu-item key="LONG">长消息</a-menu-item>
					</a-menu>
				</a-dropdown>
				<!-- <a-button @click="toAdd"></a-button> -->
			</a-form-item>
		</a-form>

		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
			<!-- 执行状态 -->
			<!-- ACTIVE-现行有效 PENDING-即将实施 OBSOLETE-已废止 -->
			<!-- <template slot="implementationStatusRender" slot-scope="text, record">
				<a-tag color="green" v-if="record.implementationStatus == 'ACTIVE'">
					现行有效
				</a-tag>
				<a-tag color="#afa" v-else-if="record.implementationStatus == 'PENDING'">
					即将实施
				</a-tag>
				<a-tag color="#898989" v-else-if="record.implementationStatus == 'OBSOLETE'">
					已废止
				</a-tag>
				<a-tag v-else></a-tag>
			</template> -->
			<!-- 发布状态 1 2-->
			<template slot="publishStatusRender" slot-scope="text, record">
				<div style="display: flex;align-items: center;">
						<span   style="color: green" v-if="record.publishStatus == 'DRAFT'">
					未发布
				</span>
				<span  style="color:#87d068" v-else-if="record.publishStatus == 'PUBLISHED'">
					已发布
				</span>
				<span v-else></span>
					<!-- <a-switch :checked="!!record.publishStatus"
						@change="(checked) => handlePublishChange(checked, record)" />
					<a-tag style="margin-left: 10px;" color="green" v-if="record.publishStatus == 'DRAFT'">
						启用
					</a-tag>
					<a-tag style="margin-left: 10px;" color="#898989" v-else-if="record.publishStatus == 'PUBLISHED'">
						禁用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else></a-tag> -->
				</div>

			</template>
			<!-- 消息内容 展开/收起 -->
						<template slot="showContentRender" slot-scope="text, record">
				<div class="content-cell">
					<div :class="['content-text', { 'content-expanded': record._contentExpanded }]">{{ text }}</div>
					<a v-if="record._showToggle" class="content-toggle" @click="toggleContentExpand(record)">
						{{ record._contentExpanded ? '收起' : '展开' }}
					</a>
				</div>
			</template>
			<!-- <template slot="indexSortender" slot-scope="text, record">
				<a-input v-model.number="record.sort" placeholder="排序" type="number" @blur="handleSaveSort(record)"
					@keyup.enter="handleSaveSort(record)" /></template> -->
			<!-- 编辑/查看，删除 -->
			<template slot="action" slot-scope="text, record">
				<div class="flex_center">
					<span><a-button v-if="record.publishStatus !== 'PUBLISHED'" type="link" @click="toEdit(record)">编辑</a-button>
					<a-button v-else type="link" @click="toView(record)">查看</a-button></span>
                <a-popconfirm title="你确定删除这条信息吗？" okText="确定" cancelText="取消" @confirm="sureDelete(record)">
						<a-button type="link">删除</a-button>
					</a-popconfirm>
				</div>
			</template>

		</a-table>
		<a-modal :title="editModel.readOnly ? '查看消息' : '发布消息'" :visible="editModel.flag" width="800px" :footer="editModel.readOnly ? null : undefined" @ok="editModel.onOk"
			@cancel="editModel.flag = false">
			<a-form-model ref="formRef" :model="editModel" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
				<!-- 发布渠道 单选框 -->
				<a-row>
					<a-col :span="24">
					<a-form-model-item label="发布渠道" prop="lang">
						<a-radio-group v-model="editModel.lang" :disabled="editModel.readOnly" style="display:inline-flex;align-items:center;">
							<a-radio value="CH">小程序</a-radio>
							<a-radio value="EN">英文版</a-radio>
						</a-radio-group>
					</a-form-model-item>
					</a-col>
				</a-row>

				<!-- 消息标题 输入框 -->
				<!-- 消息内容 -->
				<a-row>
					<a-col :span="24">
					<a-form-model-item label="消息标题" prop="title" >
						<a-input v-model="editModel.title" :disabled="editModel.readOnly" placeholder="请输入消息标题" />
					</a-form-model-item>
					</a-col>
				</a-row>

				<!-- 消息内容 -->
				<a-row>
					<a-col :span="24">
					<!-- 短消息(CH)：textarea -->
					<a-form-model-item v-if="editModel.messageType === 'SHORT'" label="消息内容" prop="content" >
						<a-textarea
						v-model="editModel.content"
						:disabled="editModel.readOnly"
						:maxlength="300"
						show-count
						rows="12"
						placeholder="请输入内容"
						/>
					</a-form-model-item>
					<!-- 长消息(EN)：封面图片 -->
					<a-form-model-item v-if="editModel.messageType === 'LONG'" label="封面图片" prop="coverImage" required>
						<div style="display:flex;align-items:center;">
							<div v-if="editModel.coverImage">
								<img :src="editModel.coverImage" style="width:80px;height:80px;object-fit:cover;" />
							</div>
							<div v-if="!editModel.readOnly" class="again_upload_box ml12">
								<a-spin v-if="coverUploadLoading" />
								<template v-else>
									<input type="file" accept="image/*" @change="handleUploadCover" />
									<i class="el-icon-box again_upload_icon"></i>
									<div class="bold" style="width:100px">{{ editModel.coverImage ? "重新上传" : "上传封面" }}</div>
								</template>
							</div>
						</div>
					</a-form-model-item>
					<!-- 长消息(EN)：wangEditor -->
					<a-form-model-item v-if="editModel.messageType === 'LONG'" label="消息内容" prop="content">
						<div ref="wangEditor" style="width:100%;"></div>
					</a-form-model-item>
					</a-col>
				</a-row>

				<!-- 定时发布 复选框 + 时间选择器 -->
				<a-row :gutter="20">
					<a-col :span="24">
					<a-form-model-item label="定时发布">
						<div style="display: flex; align-items: center; gap: 10px;">
						<a-checkbox v-model="editModel.isScheduled" :disabled="editModel.readOnly">定时发布</a-checkbox>
						<a-date-picker
							v-model="editModel.scheduledTime"
							format="YYYY-MM-DD HH:mm:ss"
							valueFormat="YYYY-MM-DD HH:mm:ss"
							show-time
							placeholder="请选择定时时间"
							style="flex:1;"
							:disabled="editModel.readOnly || !editModel.isScheduled"
						/>
						</div>
					</a-form-model-item>
					</a-col>
				</a-row>
				</a-form-model>
		</a-modal>


		<a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk"
			@cancel="tipsModel.flag = false">
			<div>底部内容</div>
			<div><a-input v-model.number="tipsModel.bottomTitle" placeholder="标题" /></div>
			<div><a-input v-model.number="tipsModel.bottomContent" placeholder="内容" /></div>
		</a-modal>

	</div>
</template>

<script>
	import E from 'wangeditor'
	import {
		ossUpload
	} from "../../utils/oss";
	import {
		getSystemMsgListApi, //  执行标准列表
		getSystemMsgDetailApi, //  执行标准详情
		editSystemMsgApi, //  执行标准新增/编辑
		deleteSystemMsgApi, //    执行标准删除
	} from "../../api/index";
	export default {
		name: "cardsList",
		data() {
			return {
				editorOption: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike'],
							['color', 'background'], // 颜色功能在这里
							['clean']

						],
					},
					placeholder: "请输入内容",
					theme: 'snow'
				},
				commodityStatusList: [{
						label: "现行有效",
						value: 'ACTIVE',
					},
					{
						label: "即将实施",
						value: 'PENDING',
					},
					{
						label: "已废止",
						value: 'OBSOLETE',
					},
				],
				columns: [{
						title: '消息标题',
						dataIndex: 'title',
						key: 'title',
						width: 160,
						customRender: (text) => {
							if (text && text.length > 8) {
								return text.substring(0, 8) + '...';
							}
							return text;
						}
					},
					{
						title: '消息内容',
						dataIndex: 'showContent',
						key: 'showContent',
						scopedSlots: {
							customRender: 'showContentRender'
						},
					},
					{
						title: '发布状态',
						dataIndex: 'publishStatus',
						key: 'publishStatus',
						scopedSlots: {
							customRender: 'publishStatusRender'
						},
						width: 150
					},
					{
						title: '发布时间',
						dataIndex: 'scheduledTime',
						key: 'scheduledTime',
						width: 200
					},
					{
						title: '发布人',
						dataIndex: 'publisher',
						key: 'publisher',
						width: 150
					},
					{
						title: '操作',
						key: 'action',
						scopedSlots: {
							customRender: 'action'
						},
						width: 150
					}
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				tipsModel: {
					flag: false,
					title: "",
					bottomTitle: "",
					bottomContent: "",
					type: 'STANDAR',
					onOk: () => {},
				},
				rules: {
				lang: [
					{ required: true, message: '请选择发布渠道', trigger: 'change' }
				],
				title: [
					{ required: true, message: '请输入消息标题', trigger: 'blur' }
				],
				content: [
					{ required: true, message: '请输入消息内容', trigger: 'blur' }
				],
				coverImage: [
					{ required: true, message: '请上传封面图片', trigger: 'change' }
				]
			},
			editModel: {
					flag: false,
					title: "",
					"title": "", //消息标题
					"content": "", //内容
					"scheduledTime": null, //定时发布时间
					"coverImage": "", //封面图片URL
					"isScheduled": false, //是否定时
					"lang": "CH", //EN  CH
					onOk: () => {},
				},
				formState: {
					"iconUrl": "", //卡片图标
					"name": "", //卡片名称
					"sort": 1 //序号
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
				filterData: {
					keywords: null,
					lang: "CH",
					timeDate:[]
				},
				tags: [],
				deptText: "",
				deptList: [],
				mainText: "",
				mainList: [],
				coverUploadLoading: false,
				editor: null,
			};
		},
		created() {},
		activated() {},
		watch: {
			'editModel.flag'(val) {
				if (val && this.editModel.messageType === 'LONG') {
					this.$nextTick(() => this.initEditor())
				} else if (!val) {
					if (this.editor) {
						try { this.editor.destroy() } catch(e) {}
					}
					this.editor = null
				}
			},
			'editModel.messageType'(val) {
				if (val === 'LONG' && this.editModel.flag) {
					this.$nextTick(() => this.initEditor())
				}
			}
		},
		mounted() {
			const storedQuery = localStorage.getItem('executionStandard_searchQuery');
			if (storedQuery) {
				this.filterData = JSON.parse(storedQuery);
			} else {}
			this.getData(1)
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('executionStandard_searchQuery', JSON.stringify(this.filterData));
			next();
		},
		methods: {
			toggleContentExpand(record) {
				this.$set(record, '_contentExpanded', !record._contentExpanded);
			},
			checkContentOverflow() {
				this.$nextTick(() => {
					const els = this.$el.querySelectorAll('.content-cell .content-text');
					(this.tableData || []).forEach((item, i) => {
						const el = els[i];
						this.$set(item, '_showToggle', el ? el.scrollHeight > el.clientHeight : false);
					});
				});
			},
			initEditor() {
				this.$nextTick(() => {
					const el = this.$refs.wangEditor
					if (!el || this.editor) return
					this.editor = new E(el)
					this.editor.config.height = 300
					this.editor.config.customUploadImg = (files, insert) => {
						files.forEach(file => {
							if (file.size > 3 * 1024 * 1024) { this.$message.error(file.name + ' 不能超过3MB'); return }
							ossUpload(file, '', 'image/').then(res => { insert(res.url) }).catch(() => { this.$message.error('图片上传失败') })
						})
					}
					this.editor.config.onchange = (html) => { this.editModel.content = html; this.$refs.formRef && this.$refs.formRef.clearValidate('content') }
					this.editor.create()
					if (this.editModel.content) {
						this.editor.txt.html(this.editModel.content)
					}
					if (this.editModel.readOnly) {
						this.editor.disable()
					}
				})
			},
			handleUploadCover(e) {
				if (!e.target.files.length) return
				const file = e.target.files[0]
				if (file.size > 3 * 1024 * 1024) { this.$message.error('图片不能超过3MB'); return }
				this.coverUploadLoading = true
				ossUpload(file, '', 'image/').then(res => {
					this.editModel.coverImage = res.url
					this.$refs.formRef.clearValidate('coverImage')
					this.$message.success('封面上传成功')
				}).catch(() => {
					this.$message.error('封面上传失败')
				}).finally(() => {
					this.coverUploadLoading = false
				})
				e.target.value = ''
			},

			handleMenuClick({ key }) {
				this.toAdd(key);
			},
			changeTabTop() {
				this.pageInfo.current = 1;
				this.getData(1); // 重新拉取列表接口，把tagTypeCategory传给后端筛选
			},

			changeTab() {
				this.pageInfo.current = 1;
				this.getData(1); // 重新拉取列表接口，把tagTypeCategory传给后端筛选
			},
			deleteDept(index) {
				this.deptList.splice(index, 1);
			},
			addDept() {
				if (!this.deptText) return;
				this.deptList.push(this.deptText);
				this.deptText = '';
			},
			deletemain(index) {
				this.mainList.splice(index, 1);
			},
			addMain() {
				if (!this.mainText) return;
				this.mainList.push(this.mainText);
				this.mainText = '';
			},
			getTagsLabel() {
				// getTagCategoriesApi({
				// 	tagTypeCategory: 'EXECUTION_STANDARD'
				// }).then((res) => {
				// 	if (res.resultStatus) {
				// 		this.tags = res.resultData[0].tags

				// 	} else {}

				// })


			},
			handleCategoryChange() {
				// 切换分类后，重置页码并刷新表格
				this.pageInfo.current = 1;
				this.loadTableData();
			},
			handleSwitch(checked) {
				this.editModel.standardStatus = checked
			},


			handleBlur() {
				console.log('blur');
			},
			handleFocus() {
				console.log('focus');
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
			toSearch(flag) {
				if (flag) {
					this.getData(1);
				} else {
					this.filterData = {
						keywords: null,
						lang: "CH",
						timeDate:[]
					};
					this.getData(1);
				}
			},
			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				const timeArr = this.filterData.timeDate || [];
				getSystemMsgListApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						lang: this.filterData.lang,
						keywords: this.filterData.keywords,
						 startDate: timeArr.length === 2
						? this.$moment(timeArr[0]).format("YYYY-MM-DD")
						: null,
						endDate: timeArr.length === 2
						? this.$moment(timeArr[1]).format("YYYY-MM-DD")
						: null,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.dataList || [];
							this.pageInfo.total = res.resultData.totalNum || 0;
							this.$nextTick(() => this.checkContentOverflow());

						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			toAdd(key) {
				this.editModel = {
					flag: true,
					title: "",
					messageType: key || 'SHORT',
					lang: this.filterData.lang === 'CH' ? 'CH' : 'EN',
					"titleText": "", //消息标题
					"content": "", //内容
					"scheduledTime": null, //定时发布时间
					"coverImage": "", //封面图片URL
					"isScheduled": false, //是否定时
					onOk: this.sureEdit,
				};
				this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
			},
			toEdit(data) {
				getSystemMsgDetailApi({
						messageId: data.messageId,
					})
					.then((res) => {
						if (res.resultStatus) {
							const result = res.resultData;
							this.editModel = {
								   flag: true,
									title: "编辑",
									messageId: result.messageId ?? '',
									messageType: result.messageType ?? 'SHORT',
									lang: result.lang ?? 'CH',
									title: result.title ?? '消息标题',
									coverImage: result.coverImage ?? '封面图片URL',
									content: result.content ?? '消息内容',
									publishStatus: result.publishStatus ?? 'DRAFT',
									isScheduled: result.isScheduled ?? true,
									publisher: result.publisher ?? 'admin',
									scheduledTime: result.scheduledTime ?? null,
									onOk: this.sureEdit,
							};
						} else {
						}
					})
					.catch((error) => {
					});
			},
			toView(data) {
				getSystemMsgDetailApi({
						messageId: data.messageId,
					})
					.then((res) => {
						if (res.resultStatus) {
							const result = res.resultData;
							this.editModel = {
								   flag: true,
									readOnly: true,
									messageId: result.messageId ?? '',
									messageType: result.messageType ?? 'SHORT',
									lang: result.lang ?? 'CH',
									title: result.title ?? '',
									coverImage: result.coverImage ?? '',
									content: result.content ?? '',
									publishStatus: result.publishStatus ?? 'DRAFT',
									isScheduled: result.isScheduled ?? true,
									publisher: result.publisher ?? '',
									scheduledTime: result.scheduledTime ?? null,
									onOk: null,
							};
						} else {
						}
					})
					.catch((error) => {
					});
			},
			confirm() {

			},
			sureScript(data) {
			},
			// 话术编辑
			scriptEdit() {
				this.tipsModel = {
					flag: true,
					title: "执行标准页面话术编辑",
					bottomTitle: "",
					bottomContent: "",
					onOk: this.sureScript,
				};
			},
			sureEdit(data) {
				this.$refs.formRef.validate().then(() => {
				editSystemMsgApi({
						messageId: this.editModel.messageId || 0,
						"title":  this.editModel.title,
						"content": this.editModel.content,
						"scheduledTime": this.editModel.scheduledTime,
						"coverImage": this.editModel.coverImage,
						"isScheduled": this.editModel.isScheduled,
						"lang":  this.editModel.lang,
					"messageType": this.editModel.messageType
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								this.editModel.executionStandardId ? "编辑成功" : "新增成功"
							);
							this.editModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.getData(this.pageInfo.current)
					})
				})
			},			sureDelete(record) {
				deleteSystemMsgApi({
					messageId: record.messageId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("删除成功");
						} else {
						}
					})
					.catch((error) => {
					})
					.finally(() => {
						this.loading = false;
						this.getData(this.pageInfo.current);
					});
			},
			// 上传文件
			handleUploadThumbnail(e) {
				if (e.target.files.length) {
					const file = e.target.files[0];
					if (file) {
						ossUpload(file, '', 'pdf/').then((res) => {
							this.editModel.standardDocument = res.url;
						}).catch(err => {
							this.$message.error('图片上传失败')
						});
					}
				}
			},
		},
	};
</script>

<style lang="less">
	.container_page {
		padding: 20px;
		background: #ffffff;

		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}
	}

	.size_item {
		height: 50px;
		/* 改为固定高度，不要 min-height */
		background: #f7f7f7;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 8px 0;
		/* 间距改小，更美观 */
		cursor: move;
		padding: 0 10px;

		.left {
			flex: 1;
			padding-left: 10px;
		}

		.right {
			width: 50px;
			text-align: center;
		}
	}

	.lang-radio-wrap {
		display: flex;
		justify-content: center;
		margin-bottom: 16px;
	}

	/* 消息内容 展开/收起 */
	.content-cell {
		position: relative;
	}
	.content-text {
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: break-all;
		line-height: 1.5;
		padding-right: 36px;
	}
	.content-text.content-expanded {
		-webkit-line-clamp: none;
		display: block;
		overflow: visible;
	}
	.content-toggle {
		position: absolute;
		right: 0;
		bottom: 0;
		cursor: pointer;
		color: #1890ff;
		font-size: 12px;
		line-height: 1.5;
		padding-left: 4px;
	}
	.content-text.content-expanded ~ .content-toggle {
		bottom: 0;
	}
	/* wangEditor 下拉菜单裁剪修复 */
	.w-e-toolbar {
		z-index: 99999 !important;
	}
</style>
